<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules" label-width="128px">
        <el-form-item class="half" label="付款人" prop="payCustomerName">
          <el-input disabled v-model.trim="dialogForm.payCustomerName" clearable placeholder="请输入付款人" />
        </el-form-item>
        <el-form-item class="half" label="收款人" prop="receivedCustomerName">
          <el-input disabled v-model.trim="dialogForm.receivedCustomerName" clearable placeholder="请输入收款人" />
        </el-form-item>
        <el-form-item class="half" :label="type === 'pay' ? '当前未付款金额' : '当前未收款金额'" prop="outstandingAmount">
          <el-input disabled v-model.trim="dialogForm.outstandingAmount" clearable />
        </el-form-item>
        <el-form-item class="half" :label="type === 'pay' ? '付款金额' : '收款金额'" prop="payAmount">
          <el-input v-model.trim="dialogForm.payAmount" clearable @input="handleInput" @blur="handleBlur" :placeholder="type === 'pay' ? '请输入付款金额' : '请输入收款金额'" />
        </el-form-item>
        <el-form-item class="half" :label="type === 'pay' ? '付款方式' : '收款方式'" prop="payWay">
          <el-select-dict dictType="PAY_WAY" v-model.trim="dialogForm.payWay" clearable :placeholder="type === 'pay' ? '请选择付款方式' : '请选择收款方式'"/>
        </el-form-item>
        <el-form-item class="half" :label="type === 'pay' ? '付款时间' : '收款时间'" prop="payTime">
          <el-date-picker v-model="dialogForm.payTime" type="datetime" :placeholder="type === 'pay' ? '请选择付款时间' : '请选择收款时间'">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="all" :label="type === 'pay' ? '付款截图' : '收款截图'" prop="payScreenshotList">
          <xiaobu-upload-img @imgChange="handleImgChange" :max="9"
            :imgList="dialogForm.payScreenshotList"></xiaobu-upload-img>
        </el-form-item>
        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
        <el-form-item class="all" label="">
          <el-checkbox v-model="checked">我已知晓：<span style="color: #F56C6C">“新增成功后记录不可删除，不可编辑”</span>，请仔细检查填写的内容，请确认无误后再进行新增。</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import XiaobuUploadImg from "@/components/upload-img/index.vue"
import { payRecordApi, commonApi } from "@/api"
export default {
  name: "PaidRecord",
  components: {
    XiaobuUploadImg
  },
  props: {
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    const checkPayAmount = (rule, value, callback) => {
      if (Number(value) <= 0) {
        callback(new Error("付款金额必须大于0"))
      } else if (Number(value) > Number(this.dialogForm.outstandingAmount)) {
        callback(new Error("付款金额不能大于当前未结款金额"))
      } else {
        callback()
      }
    }
    return {
      checked: false, // 是否已知晓
      type: "pay",
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        receivedCustomerName: [
          {required: true, message: "收款人姓名不能为空", trigger: "blur"}
        ], //收款人姓名
        payCustomerName: [
          {required: true, message: "付款人姓名不能为空", trigger: "blur"}
        ], // 付款人姓名
        outstandingAmount: [
          {required: true, message: "当前未结款金额不能为空", trigger: "blur"}
        ], // 当前未结款金额
        payTime: [
          {required: true, message: "请选择付款时间", trigger: "change"}
        ], // 付款时间
        payWay: [
          {required: true, message: "请选择付款方式", trigger: "change"}
        ], // 付款方式
        payAmount: [
          {required: true, message: "请输入付款金额", trigger: "blur"},
          {validator: checkPayAmount, trigger: "blur"}
        ], // 付款金额
        payScreenshotList: [
          {required: true, message: "请上传付款截图", trigger: "change"}
        ] // 付款截图
      }
    }
  },
  watch: {
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
        if (this.dialogForm.fundsAmount > 0) { // 我是收款人
          this.dialogForm.receivedCustomerName = "我"
          this.dialogForm.receivedCustomerId = 1
          this.dialogForm.payCustomerName = this.dialogForm.customerName
          this.dialogForm.payCustomerId = this.dialogForm.customerId
          this.type = "received"
        } else {
          this.dialogForm.receivedCustomerName = this.dialogForm.customerName
          this.dialogForm.receivedCustomerId = this.dialogForm.customerId
          this.dialogForm.payCustomerName = "我"
          this.dialogForm.payCustomerId = 1
          this.type = "pay"
        }
        this.dialogForm.outstandingAmount = Math.abs(this.dialogForm.outstandingAmount)
      },
      deep: true
    }
  },
  methods: {
    // 失去焦点事件
    handleBlur() {
      // 若输入值不为空
      if (this.dialogForm["payAmount"]) {
        // 将输入值转换为浮点数
        const num = parseFloat(this.dialogForm["payAmount"])
        // 判断是否为有效的数字
        if (!isNaN(num)) {
          // 保留两位小数
          this.dialogForm["payAmount"] = num.toFixed(2)
        }
      }
    },
    // 输入事件
    handleInput() {
      let value = this.dialogForm["payAmount"]
      // 移除非数字和小数点的字符
      value = value.replace(/[^\d.]/g, "")
      // 处理多个小数点的情况
      const parts = value.split(".")
      if (parts.length > 2) {
        value = parts[0] + "." + parts[1]
      }
      // 保留最多两位小数
      const match = value.match(/^\d+(\.\d{0,2})?/)
      if (match) {
        this.dialogForm["payAmount"] = match[0]
      } else {
        this.dialogForm["payAmount"] = ""
      }
    },
    // 图片改变事件
    handleImgChange(payScreenshotList) {
      this.dialogForm.payScreenshotList = payScreenshotList
      this.$nextTick(() => {
        this.$refs.dialogFormRef.validateField("payScreenshotList")
      })
    },

    // 重置表单
    resetForm() {
      this.$nextTick(() => {
        this.checked = false
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    async submitForm() {
      const _this = this
      this.$refs["dialogFormRef"].validate(async(valid) => {
        if (valid) {
          if (!this.checked) {
            await this.$modal.confirm("新增成功后记录不可删除，不可编辑，确认本次新增信息无误？", {
              beforeClose: (action, instance, done) => {
                // 关闭前调整遮罩层
                _this.mixinRemoveAndAddMask()
                done()
              }
            })
          }
          const list = []
          for (let i = 0; i < this.dialogForm.payScreenshotList.length; i++) {
            const item = this.dialogForm.payScreenshotList[i]
            if (item.raw) {
              const formData = new FormData()
              formData.append("file", item.raw, item.name)
              const data = await commonApi.upload(formData)
              if (!data) { continue }
              list.push(data.url)
            }
          }
          this.dialogForm.payScreenshot = list.join(",")
          const params = JSON.parse(JSON.stringify(this.dialogForm))
          delete params.payScreenshotList
  
          //新增
          payRecordApi.createItem(this.dialogForm).then((data) => {
            this.$modal.msgSuccess("新增付款记录成功")
            this.$emit("close")
            this.$emit("successs")
          })
        }
      })
    }
  }
}
</script>
